// Frontend date + number utilities. Indian-first formatting.
const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

/**
 * Format a date/ISO string as `28/April/2026`.
 * Returns "" for falsy input and a safe fallback for invalid dates.
 */
export function formatIndianDate(input) {
  if (!input) return "";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return String(input);
  const day = String(d.getDate()).padStart(2, "0");
  return `${day}/${MONTHS[d.getMonth()]}/${d.getFullYear()}`;
}

/**
 * Short variant — `28/Apr/2026` — for compact list rows / badges.
 */
export function formatIndianDateShort(input) {
  if (!input) return "";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return String(input);
  const day = String(d.getDate()).padStart(2, "0");
  return `${day}/${MONTHS[d.getMonth()].slice(0, 3)}/${d.getFullYear()}`;
}

export function formatCurrencyINR(n) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  }).format(Number(n) || 0);
}

export function docNouns(company) {
  const gstRegistered =
    company && company.gst_registered !== undefined
      ? !!company.gst_registered
      : !!(company && (company.gst_number || "").trim());
  return gstRegistered
    ? {
        title: "TAX INVOICE",
        singular: "Invoice",
        numberLabel: "Invoice Number",
        dateLabel: "Invoice Date",
        isBill: false,
      }
    : {
        title: "BILL",
        singular: "Bill",
        numberLabel: "Bill Number",
        dateLabel: "Bill Date",
        isBill: true,
      };
}

/**
 * Convert a stored `Net 7 / Net 15 / Net 30 / Custom / Due on Receipt` value
 * into a clear human-readable phrase. If a `dueDate` is provided we show that
 * directly as "Payment Due By 28/April/2026" — most concrete to the customer.
 */
export function paymentTermsLabel(termsValue, dueDate, paymentTermsDays) {
  if (dueDate) {
    return `Payment Due By ${formatIndianDate(dueDate)}`;
  }
  if (!termsValue) {
    if (paymentTermsDays && Number(paymentTermsDays) > 0) {
      return `Payment Due Within ${paymentTermsDays} Days`;
    }
    return "";
  }
  const v = String(termsValue).trim();
  if (/^due on receipt$/i.test(v)) return "Payment Due On Receipt";
  const m = v.match(/^net\s+(\d+)$/i);
  if (m) return `Payment Due Within ${m[1]} Days`;
  if (/^custom$/i.test(v)) {
    if (paymentTermsDays && Number(paymentTermsDays) > 0) {
      return `Payment Due Within ${paymentTermsDays} Days`;
    }
    return "Payment Due — Custom Terms";
  }
  return v;
}
